import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReadOnlyField from '../../../../../common/components/ReadOnlyField';
import { LockIcon } from '../../../../../common/icons/redesignIcons';

import './RegPerson.css';

@inject('translationsStore', 'moveinStore')
@observer
export default class RegPerson extends Component {
  render() {
    const { translationsStore, moveinStore } = this.props;
    return (
      <div className="RegPerson">
        <div className="RegPersonHeader">
          <span className="mv-section-title">{translationsStore.translate('registration.personalData.title')}</span>
          <span className="mv-chip">
            <LockIcon size={11} color="currentColor" />
            {translationsStore.translate('movein.stepCheckData.fromRegionChip')}
          </span>
        </div>
        <div className="RegPersonFields">
          <ReadOnlyField label={translationsStore.translate('registration.personalData.name')} value={moveinStore.user.first_name} />
          <ReadOnlyField label={translationsStore.translate('registration.personalData.surname')} value={moveinStore.user.last_name} />
          <ReadOnlyField label={translationsStore.translate('registration.personalData.taxNumber')} value={moveinStore.user.tax_code} />
        </div>
      </div>
    );
  }
}
